export const TextField = ({
  name,
  value,
  onChange,
  disabled,
  readOnly,
  required,
}) => {
  return (
    <input
      type="text"
      className={`form-control form-control-sm ${
        required && !value ? "border-danger" : ""
      }`}
      style={{
        minWidth: "120px",
        // width: "120px", // All cells same width
        height: "28px", // Excel-like height
        padding: "2px 6px",
        margin: 0,
        borderRadius: 0,
        fontSize: "13px",
        boxSizing: "border-box",
      }}
      value={value}
      disabled={disabled}
      readOnly={readOnly}
      onChange={(e) => onChange(name, e.target.value)}
    />
  );
};
